<template>
	<div class="middleBox"> 
		<div class="stepForm">

			<div class="row" >
				
				<div class="col-12 text-center">

					<div class="icon mb-5">
                        <img src="../../../../static/fxView/images/test.svg" alt="Email Support" width="220">
                    </div>
					<p class="mb-3"> {{$t('doLaterMsz')}}</p>
					
					<div class="row">
						<div class="col-12">
		                    <div class="full-width border-top pt-3  mt-3 w-100">
		                        <router-link :to="'/dashboard'" class="prism_btn btn_xs">{{$t('goToDash')}}</router-link>
		                    </div>
		                </div>
					</div>
				</div> 
			</div>
		</div>
	</div>
</template>
<script>
    import { fxViewMixins } from '@/plugins/fxView'
    export default {
        name: 'doLater',
        mixins: [fxViewMixins],
        data() {
            return {
            	
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/fxView/registerSteps/do_later.vue